import { common } from "../common";

// Canonical list-unsubscribe header scope values from shared_constants.json
// LIST_UNSUBSCRIBE.SCOPES, codified in
// shared_code/domains/channel_email/public/braze/channels/email/list_unsubscribe_fields.rb
// HeaderScopes.
//
// 0 = USE_WORKSPACE_DEFAULT
// 1 = UNSUBSCRIBE_GLOBALLY_FROM_ALL_EMAILS
// 2 = UNSUBSCRIBE_FROM_SPECIFIC_SUBSCRIPTION_GROUP
// 3 = USE_CUSTOM_URL
// 4 = EXCLUDE_UNSUBSCRIBE
export const listUnsubscribeScopeSchema = common.numericEnum([0, 1, 2, 3, 4]);
